import { render } from "./EditorialCollectionComponent.vue?vue&type=template&id=905ed992&scoped=true"
import script from "./EditorialCollectionComponent.vue?vue&type=script&lang=js"
export * from "./EditorialCollectionComponent.vue?vue&type=script&lang=js"

import "./EditorialCollectionComponent.vue?vue&type=style&index=0&id=905ed992&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-905ed992"]])

export default __exports__